import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-toggle',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ToggleSwitchModule],
  template: `
    <div class="flex items-center gap-3 py-1">
      <p-toggleswitch [formControl]="formControl" />
      <span class="text-sm font-medium text-slate-600 dark:text-slate-400">
        {{ config.placeholder || config.label }}
      </span>
    </div>
  `
})
export class ToggleFieldComponent {
  readonly config  = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);
  get formControl(): FormControl { return this.control as FormControl; }
}
